import React from 'react';
import { BgisShowDetails } from './BgisShowDetails';

export type BgisSearchProps = {
  children?: React.ReactNode;
};

export const BgisSearch = ({ children }: BgisSearchProps) => {

  return (
    <section className='bgis-search bgis-toggled-overlayable'>{children}
    <BgisShowDetails></BgisShowDetails>
    </section>
  );
};
